// TODO VSO [WI #93725]: [Consolidate telemetry bucket utils for second lengths for long term logging]
export function tokenExpiryBucket(
    tokenExpiryInSeconds: number
): {
    lowerBoundSeconds: number | null;
    upperBoundSeconds: number | null;
} {
    if (tokenExpiryInSeconds <= 0) {
        return { lowerBoundSeconds: null, upperBoundSeconds: 0 };
    } else if (tokenExpiryInSeconds <= 30) {
        return { lowerBoundSeconds: 0, upperBoundSeconds: 30 };
    } else if (tokenExpiryInSeconds <= 60) {
        return { lowerBoundSeconds: 30, upperBoundSeconds: 60 };
    } else if (tokenExpiryInSeconds <= 300) {
        return { lowerBoundSeconds: 60, upperBoundSeconds: 300 };
    } else if (tokenExpiryInSeconds <= 600) {
        return { lowerBoundSeconds: 300, upperBoundSeconds: 600 };
    } else if (tokenExpiryInSeconds <= 1800) {
        return { lowerBoundSeconds: 600, upperBoundSeconds: 1800 };
    } else if (tokenExpiryInSeconds <= 3600) {
        return { lowerBoundSeconds: 1800, upperBoundSeconds: 3600 };
    } else if (tokenExpiryInSeconds <= 21600) {
        return { lowerBoundSeconds: 3600, upperBoundSeconds: 21600 };
    } else if (tokenExpiryInSeconds <= 43200) {
        return { lowerBoundSeconds: 21600, upperBoundSeconds: 43200 };
    } else if (tokenExpiryInSeconds <= 86400) {
        return { lowerBoundSeconds: 43200, upperBoundSeconds: 86400 };
    } else if (tokenExpiryInSeconds > 86400) {
        return { lowerBoundSeconds: 86400, upperBoundSeconds: null };
    } else {
        return { lowerBoundSeconds: null, upperBoundSeconds: null };
    }
}
